import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetCommonFilter } from "./request";
import { SetCommonFilterHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapSetCommonFilter = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SetCommonFilter, SetCommonFilterHandler);
};

export const teardownSetCommonFilter = () => {
  request?.dispose();
};
